const messages = {
    en: {
        delivery: {
            surveys: {
                title: 'Surveys',
                subtitle: 'Surveys Management',
                labels: {
                    name: 'Name',
                    description: 'Description',
                    questions: 'Questions',
                    question: 'Question',
                    options: 'Options',
                    optionValue: 'OptionValue',
                    information: 'Survey Information'
                },
                rules: {
                    options: 'At least 2 options are required.',
                    questions: 'At least 1 question is required.'
                },
                creating: 'Creating Survey',
                showing: 'Showing Survey',
                editing: 'Survey Edition',
                deleting: 'Survey Deletion',
                response: {
                    send: 'Send survey'
                }
            }
        }
    },
    es: {
        delivery: {
            surveys: {
                title: 'Encuestas',
                subtitle: 'Gestión de Encuestas',
                labels: {
                    name: 'Nombre',
                    description: 'Descripción',
                    questions: 'Preguntas',
                    question: 'Pregunta',
                    options: 'Opciones',
                    optionValue: 'Valor de opción',
                    information: 'Información de la encuesta'
                },
                rules: {
                    options: 'Se requieren almenos 2 opciones.',
                    questions: 'Se requiere almenos 1 pregunta.'
                },
                creating: 'Creación de encuesta',
                showing: 'Visualización de encuesta',
                editing: 'Edición de encuesta',
                deleting: 'Eliminación de encuesta',
                response: {
                    send: 'Enviar encuesta'
                }
            }
        }
    },
    pt: {
        delivery: {
            surveys: {
                title: 'Pesquisas',
                subtitle: 'Gerenciamento de Pesquisas',
                labels: {
                    name: 'Nome',
                    description: 'descrição',
                    questions: 'Questões',
                    question: 'pergunta',
                    options: 'Opções',
                    optionValue: 'Valor da opção',
                    information: 'Informações da Pesquisa'
                },
                rules: {
                    options: 'Es requerido dos opciones.',
                    perguntas: 'Pelo menos 1 pergunta é necessária.'
                },
                creating: 'Criação de Pesquisa',
                showing: 'Mostrando Pesquisa',
                editing: 'Edição de Pesquisa',
                deleting: 'Exclusão de pesquisa',
                response: {
                    send: 'Enviar pesquisa'
                }
            }
        }
    }

}


export default messages
